<template>
  <main-sidebar :name="name" :title="$t('bank_account')">
    <div class="p-4">
      <vs-row vs-w="12" class="mb-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('client') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <v-select
            v-model="form.client"
            :options="clientList"
            class="w-full"
            :reduce="(client) => client.ClientId"
            label="ClientName"
            :disabled="isEditing"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('bank') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <v-select
            v-model="form.bank"
            :options="bankList"
            class="w-full"
            :reduce="(bank) => bank.id"
            label="short_name"
            :disabled="isEditing"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('account_number') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <vs-input
            class="w-full"
            v-validate="'required'"
            v-model="form.account"
            name="account"
            autocomplete="off"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('currency') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <v-select
            v-model="form.currency"
            :options="currencies"
            class="w-full"
            :reduce="(currency) => currency.id"
            label="name"
          />
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-xs="12"
          vs-sm="8"
          vs-lg="8"
        >
          <vs-checkbox v-model="form.cash_request_account">{{
            $t('cash_request_account')
          }}</vs-checkbox>
        </vs-col>
      </vs-row>
    </div>
    <div class="mx-4" slot="footer">
      <vs-button color="primary" type="filled" class="mr-6" @click="submit">
        {{ $t('submit') }}
      </vs-button>
      <vs-button color="primary" type="border" @click="close">
        {{ $t('cancel') }}
      </vs-button>
    </div>
  </main-sidebar>
</template>

<script>
import MainSidebar from '@/views/components/MainSidebar.vue'
import InputDate from '@/components/custom/InputDate'
import vSelect from 'vue-select'
import loading from '@/mixins/Loading'
import validate from '@/mixins/Validate.js'

export default {
  components: {
    MainSidebar,
    vSelect,
    InputDate,
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === this.name
    },
    isLoading() {
      return this.loading.submit
    },
    isEditing() {
      return Object.keys(this.bankAccount).length !== 0
    },
  },
  data: () => ({
    name: 'bank-account',
    loading: {
      submit: false,
    },
    form: {
      client: '',
      bank: '',
      account: '',
      currency: '',
      cash_request_account: false,
    },
    currencies: [
      { id: 'USD', name: 'USD' },
      { id: 'MXN', name: 'MXN' },
    ],
  }),
  methods: {
    clear() {
      this.form.client = ''
      this.form.bank = ''
      this.form.account = ''
      this.form.currency = ''
      this.form.cash_request_account = false
    },
    close() {
      this.$store.dispatch('toggleSidebar', '')
    },
    init() {
      this.clear()
      if (this.isEditing) {
        this.form.client = this.bankAccount.client_id
        this.form.bank = this.bankAccount.bank_id
        this.form.account = this.bankAccount.number
        this.form.currency = this.bankAccount.currency
        this.form.cash_request_account =
          this.bankAccount.cash_request === '0' ? false : true
      }
    },
    submit() {
      let action = 'bankAccount/addBankAccount'
      let data = Object.assign({}, this.form)
      if (this.isEditing) {
        action = 'bankAccount/updateBankAccount'
        data.id = this.bankAccount.id
      }
      this.loading.submit = true
      this.$store
        .dispatch(action, data)
        .then((res) => {
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Item Added',
          })
          this.loading.submit = false
          this.close()
          this.$emit('search');
        })
        .catch((res) => {
          this.loading.submit = false
          this.displayErrors(res)
        })
    },
  },
  mixins: [loading, validate],
  props: {
    clientList: {
      type: Array,
      default: () => [],
    },
    bankList: {
      type: Array,
      default: () => [],
    },
    bankAccount: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    isSidebarActive(val) {
      if (val) {
        this.init()
      }
    },
    isLoading(val) {
      if (val) {
        this.openLoading(`loading-${this.name}-sidebar`)
      } else {
        this.closeLoading(`loading-${this.name}-sidebar`)
      }
    },
  },
}
</script>

<style>
</style>